import { render, staticRenderFns } from "./left-top.vue?vue&type=template&id=00cb2fe0&scoped=true&"
import script from "./left-top.vue?vue&type=script&lang=js&"
export * from "./left-top.vue?vue&type=script&lang=js&"
import style0 from "./left-top.vue?vue&type=style&index=0&id=00cb2fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb2fe0",
  null
  
)

export default component.exports